import { useState } from 'react';
import { 
    Dumbbell,
    Target,
    Info
} from 'lucide-react';
import {Button, TextField} from '@mui/material';

type TestSessionExerciseEntryProps = {
    sessionExercise: any;
    testExercises: any[];
    exercises: any[];
    handleValueChange: (value: number, testExerciseId: string) => void;
};

const TestSessionExerciseEntry: React.FC<TestSessionExerciseEntryProps> = ({ 
    sessionExercise, 
    testExercises, 
    exercises, 
    handleValueChange 
}) => {
    const testExercise = testExercises.find(ex => ex.id === sessionExercise.test_exercise_id);
    const exercise = exercises.find(ex => ex.id === testExercise?.exercise_id);

    const [metricValue, setMetricValue] = useState(sessionExercise.value);
    const [isDirty, setIsDirty] = useState(false);

    const handleButtonClick = () => {
        handleValueChange(metricValue, sessionExercise.test_exercise_id);
        setIsDirty(false);
    };

    const handleFloatChange = (val: string, min: number | 'none', max: number | 'none') => {
        let newVal = parseFloat(val.trim());
        newVal = isNaN(newVal) ? 0 : newVal;

        if (min !== 'none' && newVal < min) {
            newVal = min;
        } else if (max !== 'none' && newVal > max) {
            newVal = max;
        }

        setMetricValue(newVal);
    };

    // const handleInputChange = (value: string) => {
    //     setMetricValue(value);
    //     setIsDirty(true);
    // };

    // const handleKeyDown = (e: React.KeyboardEvent) => {
    //     if (e.key === 'Enter') {
    //         e.preventDefault();
    //         if (isDirty) {
    //             handleButtonClick();
    //         }
    //     }
    // };

    return (
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-xl mb-4">
            {/* Header */}
            <div className="bg-gradient-to-r from-amber-500 to-amber-600 p-4 text-black relative">
                <div className="absolute inset-0 bg-white opacity-10"></div>
                <div className="relative flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <Target className="w-4 h-4" />
                        <div>
                            <h3 className="font-bold text-lg">
                                Test Exercise
                            </h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="p-6">
                {/* Exercise Name */}
                <div className="mb-4">
                    <div className="flex items-center space-x-2 mb-2">
                        <Dumbbell className="w-5 h-5 text-gray-600" />
                        <h4 className="text-xl font-semibold text-gray-800 leading-tight">
                            {exercise?.name}
                        </h4>
                    </div>
                </div>

                {/* Exercise Details */}
                {testExercise?.details && (
                    <div className="mb-4">
                        <div className="bg-blue-50 rounded-lg p-4">
                            <div className="flex items-center space-x-2 mb-2">
                                <Info className="w-5 h-5 text-blue-600" />
                                <span className="font-semibold text-blue-800 text-base">Exercise Details</span>
                            </div>
                            <p className="text-lg text-blue-700 leading-relaxed">
                                {testExercise.details}
                            </p>
                        </div>
                    </div>
                )}

                {/* Value Input */}
                <div className="space-y-4">
                    <div className="bg-gray-50 rounded-lg p-4">
                        <label className="block text-base font-medium text-gray-700 mb-2">
                            {testExercise?.metric}
                        </label>
                        <TextField fullWidth style={{ width: "100%", margin: "10px 5px" }}
                            type="number"
                            id="value"
                            variant="outlined"
                            value={metricValue}
                            onBlur={(e) => {handleFloatChange(e.target.value, 0, 'none');}}
                            onChange={(e) => {setMetricValue(e.target.value); setIsDirty(true)}}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault(); // Prevent default Enter key behavior (form submission)
                                }
                            }}
                        />
                    </div>

                    {/* Save Button */}
                    <div className="flex justify-center">
                        <Button 
                            style={{cursor: 'pointer', fontSize: '12px', color: '#fff'}} 
                            onClick={handleButtonClick}
                            variant='contained'
                            disabled={!isDirty}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestSessionExerciseEntry;